/* eslint-disable */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { templateStrings } from "../../../../Constant";
import { fetchSettlementLedgerAction } from "../../../../redux/action-creators/settlementActionCreator";
import SettlementCard from "../SettlementCard";
// import CurrentDueVehicleList from "./CurrentDueVehicleList";
import { getSettlementTemplateString } from "../../../../shared/methods/sharedMethods";
import DayWiseDueList from "./DayWiseDueList";

class CurrentDue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUpdated: false,
    };
    this.getList = this.getList.bind(this);
  }

  componentDidMount() {
    this.getList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      // (prevProps && prevProps.selectedDateFilter != this.props.selectedDateFilter) ||
      (prevProps && prevProps.cityFilter != this.props.cityFilter)
      || (prevProps && prevProps.operatorFilter != this.props.operatorFilter)
      // || (prevProps && prevProps.isUpdated != this.props.isUpdated)
    ) {
      this.getList();
    }
  }

  render() {
    const { currentDueLoader } = this.props;
    const config = this.props.content?.calculationConfig;
    const gridStrings = config && getSettlementTemplateString(config, templateStrings.netDueCardGridItems);
    return (
      <div>
        <SettlementCard
          data={this.props.content}
          operatorId={this.props.operatorId}
          cityId={this.props.cityId}
          currentDueVehicles={this.props.currentDueVehicles}
          isUpdated={this.settledDone}
          gridStrings={gridStrings || {}}
          isLoading={currentDueLoader}
        />
        <DayWiseDueList
          isUpdated={this.state.isUpdated}
          operatorId={this.props.operatorId}
          cityId={this.props.cityId}
          headerLoader={currentDueLoader}
          settledDone={this.settledDone}
        />
      </div>
    );
  }

  /**
   * API call to get vehicles.
   * @param pageNo current page number
   */
  getList = () => {
    this.props.fetchSettlementLedger({
      pageNo: this.state.pageNo,
      pageSize: this.state.rowsPerPage,
      cityId: this.props.cityId,
      operatorId: this.props.operatorId,
    }, "currentDueLoader");
  };

  settledDone = () => {
    this.setState({
      isUpdated: !this.state.isUpdated,
    });
    this.props.fetchSettlementLedger({
      pageNo: this.state.pageNo,
      pageSize: this.state.rowsPerPage,
      cityId: this.props.cityId,
      operatorId: this.props.operatorId,
    }, "currentDueLoader");
  };
}

function mapStateToProps(state) {
  return {
    content: (state && state.Settlement && state.Settlement.settlementLedger) || {},
    currentDueLoader: (state && state.loadingBar && state.loadingBar.currentDueLoader),
    // selectedDateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    currentDueVehicles:
      (state && state.Settlement && state.Settlement.currentDueVehicles && state.Settlement.currentDueVehicles.data)
      || [],
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  fetchSettlementLedger: (params, loaderScope) => {
    dispatch(fetchSettlementLedgerAction(params, loaderScope));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CurrentDue));
